<template>
  <div class="nursing-execution">
    <!-- 搜索条件 -->
    <div class="compact-form-box">
      <el-tabs type="border-card" style="height: 100%">
        <el-tab-pane label="患者信息">
          <el-form :model="searchForm" label-width="80px" size="mini" class="responsive-form">
            <el-row :gutter="8" class="form-row">
              <el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="3">
                <el-form-item label="患者ID:" class="compact-form-item">
                  <el-input v-model="searchForm.patientId" placeholder="请输入" @keyup.enter.native="handleSearch" class="full-width-input" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="3">
                <el-form-item label="姓名:" class="compact-form-item">
                  <el-input v-model="searchForm.patientName" placeholder="请输入" @keyup.enter.native="handleSearch" class="full-width-input" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="3">
                <el-form-item>
                  <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                  <el-button size="mini" @click="handleReset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="medical-system-container">
      <div class="table-main-container">
        <!-- 左侧：待执行患者列表 -->
        <div class="left-tabs-container">
          <el-tabs type="border-card" class="left-tabs">
            <el-tab-pane label="待执行患者列表">
              <div class="table-container">
                <el-table
                    height="100%"
                    :data="patientData"
                    border
                    @row-click="handlePatientRowClick"
                    highlight-current-row
                    v-loading="patientLoading"
                >
                  <el-table-column fixed="left" label="行号" type="index" width="50" align="center" />
                  <el-table-column prop="patientId" label="患者ID" width="100" align="center" />
                  <el-table-column prop="patientName" label="患者姓名" width="120" align="center" />
                  <el-table-column prop="pendingExecutionCount" label="待执行任务数" width="120" align="center" />
                  <el-table-column prop="inProgressExecutionCount" label="执行中任务数" width="120" align="center" />
                  <el-table-column prop="latestOrderedAt" label="最近开单时间" min-width="160" align="center">
                    <template #default="{ row }">
                      {{ row.latestOrderedAt ? dayjs(row.latestOrderedAt).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 右侧：执行计划 -->
        <div class="right-tabs-container">
          <el-tabs type="border-card" class="right-tabs">
            <el-tab-pane label="执行计划">
              <template #label>
                <div style="display: flex; align-items: center; gap: 16px;">
                  <span>执行计划</span>
                  <span style="color: #dcdfe6;">|</span>
                  <span style="font-size: 12px; color: #606266; display: flex; align-items: center; gap: 6px;">
            执行时间:
            <el-date-picker
                v-model="selectedDate"
                type="date"
                placeholder="选择日期"
                size="mini"
                value-format="yyyy-MM-dd"
                style="width: 150px;"
                @change="handleDateChange"
                :clearable="false"
            />
          </span>
                </div>
              </template>
              <div class="table-container">
                <el-table
                    height="100%"
                    :data="planData"
                    border
                    @row-click="handlePlanRowClick"
                    highlight-current-row
                    v-loading="planLoading"
                    :span-method="objectSpanMethod"
                    row-key="_originalIndex"
                >
                  <!-- 分组列（合并单元格） -->
                  <el-table-column fixed="left" label="分组" width="80" align="center">
                    <template #default="{ row }">
                      <el-tooltip
                          v-if="row._isValidGroup"
                          :content="getGroupTooltip(row)"
                          placement="top"
                          effect="dark"
                      >
                <span style="font-weight: 600; color: #409EFF; cursor: help;">
                  {{ getGroupDisplay(row) }}
                </span>
                      </el-tooltip>
                      <span v-else style="color: #909399; font-size: 12px;">单独</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="executionNo" label="执行单号" min-width="150" align="center" show-overflow-tooltip />
                  <el-table-column prop="itemName" label="项目名称" min-width="140" align="center" show-overflow-tooltip />
                  <el-table-column prop="specification" label="规格" min-width="100" align="center" show-overflow-tooltip />
                  <el-table-column prop="itemType" label="项目类型" width="90" align="center">
                    <template #default="{ row }">
                      {{ getItemTypeLabel(row.itemType) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="quantity" label="开立数量" width="80" align="center" />
                  <el-table-column prop="unitName" label="单位" width="70" align="center" />
                  <el-table-column prop="planStatus" label="计划状态" width="100" align="center">
                    <template #default="{ row }">
                      <el-tag :type="getPlanStatusType(row.planStatus)" size="mini">
                        {{ getPlanStatusLabel(row.planStatus) }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="plannedTime" label="计划执行时间" min-width="150" align="center">
                    <template #default="{ row }">
                      {{ row.plannedTime ? dayjs(row.plannedTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="orderingDeptId" label="开单科室" width="120" align="center">
                    <template #default="{ row }">
                      {{ getDeptName(row.orderingDeptId) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="orderingDoctorId" label="开单医生" width="100" align="center">
                    <template #default="{ row }">
                      {{ getDoctorName(row.orderingDoctorId) }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-control-form">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
          <div style="font-size: 13px; color: #606266;">
            当前患者：<span style="color: #409EFF; font-weight: 600;">{{ currentPatientName || '未选择' }}</span>
            <span style="margin-left: 20px;">执行计划：<span style="color: #409EFF; font-weight: 600;">{{ planData.length }}</span> 条</span>
          </div>
          <div class="action-buttons">
            <el-button
                type="primary"
                size="small"
                :disabled="!selectedPlan || selectedPlan.planStatus !== 0"
                @click="handleExecutePlan"
            >
              执行
            </el-button>
            <el-button type="success" size="small" @click="handleViewRecords">执行记录</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 执行弹窗 -->
    <el-dialog
        title="执行计划"
        :visible.sync="executeDialogVisible"
        width="40%"
        :close-on-click-modal="false"
        class="execute-dialog"
        @closed="handleExecuteDialogClosed"
    >
      <el-form :model="executeForm" label-width="100px" size="mini">
        <el-form-item label="执行项数:">
          <el-input :value="executeForm.planIds ? executeForm.planIds.length + ' 项' : '0 项'" disabled />
        </el-form-item>
        <el-form-item label="执行单号:">
          <el-input :value="executeForm.executionNo" disabled />
        </el-form-item>
        <el-form-item label="项目名称:">
          <el-input :value="executeForm.itemName" disabled />
        </el-form-item>
        <el-form-item label="规格:">
          <el-input :value="executeForm.specification" disabled />
        </el-form-item>
        <el-form-item label="开立数量:">
          <el-input :value="executeForm.quantity" disabled />
        </el-form-item>
        <el-form-item label="执行科室:" prop="executionDeptId">
          <el-select v-model="executeForm.executionDeptId" placeholder="请选择执行科室" style="width:100%;">
            <el-option v-for="item in deptOptions" :key="item.id" :label="item.label" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
    <el-button @click="executeDialogVisible = false" size="mini">取消</el-button>
    <el-button type="primary" size="mini" @click="handleConfirmExecute" :loading="executeLoading">
      确认执行 ({{ executeForm.planIds ? executeForm.planIds.length : 0 }}项)
    </el-button>
  </span>
    </el-dialog>

    <!-- 执行记录弹窗 -->
    <el-dialog
        title="执行记录"
        :visible.sync="recordDialogVisible"
        width="80%"
        :close-on-click-modal="false"
        top="30px"
        class="record-dialog"
        @closed="handleRecordDialogClosed"
    >
      <el-form :model="recordSearchForm" label-width="80px" size="mini" inline>
        <el-form-item label="患者ID:">
          <el-input v-model="recordSearchForm.patientId" placeholder="请输入" clearable style="width:150px;" />
        </el-form-item>
        <el-form-item label="患者姓名:">
          <el-input v-model="recordSearchForm.patientName" placeholder="请输入" clearable style="width:150px;" />
        </el-form-item>
        <el-form-item label="执行状态:">
          <el-select v-model="recordSearchForm.status" placeholder="全部" clearable style="width:120px;">
            <el-option label="待执行" :value="0" />
            <el-option label="执行中" :value="1" />
            <el-option label="已完成" :value="2" />
            <el-option label="部分取消" :value="3" />
            <el-option label="全部取消" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围:">
          <el-date-picker
              v-model="recordSearchForm.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              style="width:360px;"
              size="mini"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="loadRecords">查询</el-button>
          <el-button size="mini" @click="resetRecordSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
          :data="recordDialogData"
          border
          v-loading="recordDialogLoading"
          max-height="400"
          @row-dblclick="handleRecordRowDblclick"
      >
        <el-table-column fixed="left" label="行号" type="index" width="50" align="center" />
        <el-table-column prop="executionNo" label="执行单号" min-width="160" align="center" show-overflow-tooltip />
        <el-table-column prop="patientId" label="患者ID" width="100" align="center" />
        <el-table-column prop="patientName" label="患者姓名" width="100" align="center" />
        <el-table-column prop="itemName" label="项目名称" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="specification" label="规格" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="quantity" label="开立数量" width="90" align="center" />
        <el-table-column prop="unitName" label="单位" width="70" align="center" />
        <el-table-column prop="singleDose" label="单次剂量" width="90" align="center" />
        <el-table-column prop="doseUnit" label="剂量单位" width="80" align="center" />
        <el-table-column prop="status" label="执行状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="getStatusType(row.status)" size="mini">
              {{ getStatusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="180" align="center">
          <template #default="{ row }">
            {{ row.createdAt ? dayjs(row.createdAt).format('YYYY-MM-DD HH:mm:ss') : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" label="更新时间" min-width="180" align="center">
          <template #default="{ row }">
            {{ row.updatedAt ? dayjs(row.updatedAt).format('YYYY-MM-DD HH:mm:ss') : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderingDeptId" label="开单科室" width="120" align="center">
          <template #default="{ row }">
            {{ getDeptName(row.orderingDeptId) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderingDoctorId" label="开单医生" width="100" align="center">
          <template #default="{ row }">
            {{ getDoctorName(row.orderingDoctorId) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper" style="margin-top:12px; text-align:right;">
        <el-pagination
            @size-change="handleRecordSizeChange"
            @current-change="handleRecordCurrentChange"
            :current-page="recordPageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="recordPageSize"
            :total="recordTotalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            size="mini"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false" size="mini">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 执行记录详情弹窗 -->
    <el-dialog
        title="执行记录详情"
        :visible.sync="recordDetailDialogVisible"
        width="50%"
        :close-on-click-modal="false"
        top="30px"
        class="record-detail-dialog"
    >
      <div v-loading="recordDetailLoading">
        <el-form :model="recordDetailData" label-width="140px" size="mini" disabled>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="执行记录编号:">
                <el-input v-model="recordDetailData.requestNo" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行计划ID:">
                <el-input v-model="recordDetailData.executionPlanId" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="实际执行时间:">
                <el-input :value="recordDetailData.executedAt ? dayjs(recordDetailData.executedAt).format('YYYY-MM-DD HH:mm:ss') : '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间:">
                <el-input :value="recordDetailData.createdAt ? dayjs(recordDetailData.createdAt).format('YYYY-MM-DD HH:mm:ss') : '-'" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="执行科室:">
                <el-input :value="getDeptName(recordDetailData.executionDeptId)" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行人:">
                <el-input v-model="recordDetailData.executorId" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="记录状态:">
                <el-input :value="recordDetailData.status === 1 ? '有效' : '已作废'" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="执行单是否打印:">
                <el-input :value="recordDetailData.executionPrinted === 1 ? '是' : '否'" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="输液单是否打印:">
                <el-input :value="recordDetailData.infusionPrinted === 1 ? '是' : '否'" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标签是否打印:">
                <el-input :value="recordDetailData.labelPrinted === 1 ? '是' : '否'" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="皮试批号:">
                <el-input v-model="recordDetailData.skinTestBatchNo" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="皮试结果:">
                <el-input :value="getSkinTestLabel(recordDetailData.skinTestResult)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="皮试开始时间:">
                <el-input :value="recordDetailData.skinTestStartedAt ? dayjs(recordDetailData.skinTestStartedAt).format('YYYY-MM-DD HH:mm:ss') : '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="皮试结束时间:">
                <el-input :value="recordDetailData.skinTestEndedAt ? dayjs(recordDetailData.skinTestEndedAt).format('YYYY-MM-DD HH:mm:ss') : '-'" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="皮试备注:">
                <el-input v-model="recordDetailData.skinTestRemark" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDetailDialogVisible = false" size="mini">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getExecutionPlansPatients,
  getExecutionPlans,
  executionPlansByPlanId,
  getExecutionPlansPage,
  getExecutionPlansRecords, executionPlansRefundableCharges, executionPlans
} from '@/api/reservation/outpatientChargeV2';
import dayjs from 'dayjs';

export default {
  name: 'NursingExecution',
  data() {
    return {
      selectedDate: dayjs().format('YYYY-MM-DD'),
      userInfo: null,
      searchForm: { patientId: '', patientName: '' },
      patientData: [],
      patientLoading: false,
      planData: [],
      planLoading: false,
      currentPatientId: null,
      currentPatientName: '未选择',
      selectedPlan: null,
      deptOptions: [],
      doctorOptions: [],
      executeDialogVisible: false,
      executeLoading: false,
      executeForm: {
        planIds: [],
        executionNo: '',
        itemName: '',
        specification: '',
        quantity: null,
        executionDeptId: null,
        groupKey: null
      },
      recordDialogVisible: false,
      recordDialogData: [],
      recordDialogLoading: false,
      recordSearchForm: {
        patientId: '',
        patientName: '',
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      recordPageNum: 1,
      recordPageSize: 20,
      recordTotalSize: 0,
      recordDetailDialogVisible: false,
      recordDetailLoading: false,
      recordDetailData: {},
      dayjs
    };
  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    this.loadDeptOptions();
    this.loadDoctorOptions();
    this.handleSearch();
  },

  methods: {
    handleDateChange() {
      if (this.currentPatientId) {
        const row = this.patientData.find(p => p.patientId === this.currentPatientId);
        if (row) this.handlePatientRowClick(row);
      } else {
        this.planData = [];
        this.selectedPlan = null;
      }
    },

    /**
     * 处理分组数据
     * 分组规则：groupNo + 标准化后的 plannedTime
     * 说明：只有在 groupNo 相同且 plannedTime 完全相同的项，才视为同一组
     */
    processPlanGroups(plans) {
      if (!plans || !Array.isArray(plans) || plans.length === 0) {
        return [];
      }

      // 按 groupNo + 标准化 plannedTime 分组
      const groups = {};
      plans.forEach((plan, index) => {
        if (!plan) return;

        const groupNo = plan.groupNo ?? 'noGroup';
        // ⭐ 关键：标准化 plannedTime，避免格式/精度差异导致同组被拆散或误合并
        const plannedTimeKey = plan.plannedTime
            ? dayjs(plan.plannedTime).format('YYYY-MM-DD HH:mm:ss')
            : 'noTime';
        const key = `${groupNo}_${plannedTimeKey}`;

        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push({ ...plan, _originalIndex: index });
      });

      // 处理分组
      let groupId = 0;
      const groupedResult = [];
      const singleResult = [];
      const groupKeys = Object.keys(groups);

      groupKeys.forEach((key) => {
        const groupItems = groups[key];
        if (!groupItems || !Array.isArray(groupItems) || groupItems.length === 0) {
          return;
        }

        // 有效分组：groupNo 存在 且 数量 > 1
        const isValidGroup = !key.startsWith('noGroup_') && groupItems.length > 1;

        if (isValidGroup) {
          groupId++;
          groupItems.forEach((item, idx) => {
            if (!item) return;
            item._groupKey = key;                       // ⭐ 用 groupNo_标准化时间 作为唯一分组 key
            item._groupId = groupId;
            item._groupSize = groupItems.length;
            item._isGroupFirst = idx === 0;
            item._isGroupLast = idx === groupItems.length - 1;
            item._groupSeq = idx + 1;
            item._isValidGroup = true;
            groupedResult.push(item);
          });
        } else {
          groupItems.forEach((item) => {
            if (!item) return;
            item._groupKey = null;
            item._groupId = null;
            item._groupSize = 1;
            item._isGroupFirst = true;
            item._isGroupLast = true;
            item._groupSeq = 1;
            item._isValidGroup = false;
            singleResult.push(item);
          });
        }
      });

      // 分组排前面，单独排后面
      return [...groupedResult, ...singleResult];
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row._isGroupFirst) {
          return { rowspan: row._groupSize || 1, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },

    getGroupDisplay(row) {
      if (!row._isValidGroup) return '单独';
      return `组${row._groupId}`;
    },

    getGroupTooltip(row) {
      if (!row._isValidGroup) return '单独执行';
      return `第${row._groupId}组，共${row._groupSize}项，序号 ${row._groupSeq}/${row._groupSize}`;
    },

    loadDeptOptions() {
      this.deptOptions = this.$store.getters['preload/getDeptListOptions'] || [];
    },
    loadDoctorOptions() {
      this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
    },

    getDeptName(deptId) {
      const dept = this.deptOptions.find(item => item.id === deptId);
      return dept?.label || deptId || '-';
    },
    getDoctorName(doctorId) {
      return this.doctorOptions.find(item => item.id === doctorId)?.label || '-';
    },
    getPlanStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'info' };
      return map[status] || 'info';
    },
    getPlanStatusLabel(status) {
      const map = { 0: '待执行', 1: '已完成', 2: '已取消' };
      return map[status] || '未知';
    },
    getStatusType(status) {
      const map = { 0: 'warning', 1: 'primary', 2: 'success', 3: 'info', 4: 'danger' };
      return map[status] || 'info';
    },
    getStatusLabel(status) {
      const map = { 0: '待执行', 1: '执行中', 2: '已完成', 3: '部分取消', 4: '全部取消' };
      return map[status] || '未知';
    },
    getSkinTestType(result) {
      const map = { 0: 'warning', 1: 'danger', 2: 'success' };
      return map[result] || 'info';
    },
    getSkinTestLabel(result) {
      const map = { 0: '待测试', 1: '阳性', 2: '阴性' };
      return map[result] || '未知';
    },
    getItemTypeLabel(type) {
      const map = {
        1: '西药', 2: '中药', 4: '理疗', 5: '卫材',
        6: '输液/治疗', 7: '检查', 8: '检验', 9: '挂号费', 10: '其他'
      };
      return map[type] || '其他';
    },

    handleSearch() {
      this.loadPatients();
    },

    handleReset() {
      this.searchForm = { patientId: '', patientName: '' };
      this.loadPatients();
    },

    // ========== 1. 加载待执行患者列表 ==========
    async loadPatients() {
      this.patientLoading = true;
      try {
        const params = {
          patientId: this.searchForm.patientId || undefined,
          patientName: this.searchForm.patientName || undefined
        };
        const res = await getExecutionPlansPatients(params);
        if (res.code === 200) {
          this.patientData = Array.isArray(res.data?.content) ? res.data.content : [];
        } else {
          this.$message.error(res.message || '查询失败');
          this.patientData = [];
        }
      } catch (error) {
        console.error('加载待执行患者失败:', error);
        this.$message.error('加载失败，请重试');
        this.patientData = [];
      } finally {
        this.patientLoading = false;
      }
    },

    // ========== 2. 点击患者行 → 查询该患者的执行计划 ==========
    async handlePatientRowClick(row) {
      if (!row) return;

      this.currentPatientId = row.patientId;
      this.currentPatientName = row.patientName || '未知';
      this.selectedPlan = null;
      this.planLoading = true;

      try {
        const res = await getExecutionPlans({ patientId: row.patientId, planDate: this.selectedDate });
        if (res.code === 200) {
          const rawData = Array.isArray(res.data) ? res.data : [];
          const sortedData = rawData.sort((a, b) => {
            const order = { 0: 0, 1: 1, 2: 2 };
            return (order[a?.planStatus] ?? 99) - (order[b?.planStatus] ?? 99);
          });
          this.planData = this.processPlanGroups(sortedData);
          await this.refreshCurrentPatientPlans();
        } else {
          this.$message.error(res.message || '加载执行计划失败');
          this.planData = [];
        }
      } catch (error) {
        console.error('加载执行计划失败:', error);
        this.$message.error('加载执行计划失败，请重试');
        this.planData = [];
      } finally {
        this.planLoading = false;
      }
    },

    // ========== 3. 点击执行计划行 → 选中 ==========
    handlePlanRowClick(row) {
      if (!row) return;
      this.selectedPlan = row;
    },

    // ========== 4. 执行护理计划 ==========
    handleExecutePlan() {
      if (!this.selectedPlan) {
        this.$message.warning('请选择要执行的计划');
        return;
      }

      let planIds = [];

      // ⭐ 关键修改：按 _groupKey（groupNo + 标准化时间）取同组所有待执行项
      // 这样即使 groupNo 相同但 plannedTime 不同，也不会误合并
      if (this.selectedPlan._isValidGroup && this.selectedPlan._groupKey) {
        const groupPlans = this.planData.filter(
            p => p._groupKey === this.selectedPlan._groupKey && p.planStatus === 0
        );
        planIds = groupPlans.map(p => p.planId);

        if (planIds.length === 0) {
          this.$message.warning('该分组下没有可执行的计划');
          return;
        }
      } else {
        // 单独计划：只执行当前项
        if (this.selectedPlan.planStatus !== 0) {
          this.$message.warning('该计划已执行或已取消');
          return;
        }
        planIds = [this.selectedPlan.planId];
      }

      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      const defaultDeptId = userInfo.selDept || this.selectedPlan.executionDeptId || null;

      this.executeForm = {
        planIds: planIds,
        executionNo: this.selectedPlan.executionNo || '',
        itemName: this.selectedPlan.itemName || '',
        specification: this.selectedPlan.specification || '',
        quantity: this.selectedPlan.quantity || 0,
        executionDeptId: defaultDeptId,
        groupKey: this.selectedPlan._groupKey || null   // ⭐ 用 groupKey 替代 groupNo
      };

      this.executeDialogVisible = true;
    },

    // 确认执行
    async handleConfirmExecute() {
      if (!this.executeForm.executionDeptId) {
        this.$message.warning('请选择执行科室');
        return;
      }
      if (!this.executeForm.planIds || this.executeForm.planIds.length === 0) {
        this.$message.warning('没有可执行的计划');
        return;
      }

      this.executeLoading = true;
      try {
        const params = {
          executionDeptId: this.executeForm.executionDeptId,
          planIds: this.executeForm.planIds
        };
        const res = await executionPlans(params);
        if (res.code === 200) {
          this.$message.success(`成功执行 ${this.executeForm.planIds.length} 项计划`);
          this.executeDialogVisible = false;

          await this.loadPatients();

          const patientStillExists = this.patientData.some(p => p.patientId === this.currentPatientId);
          if (patientStillExists && this.currentPatientId) {
            await this.refreshCurrentPatientPlans();
            this.selectedPlan = null;   // ⭐ 刷新后清空选中，避免引用旧对象
          } else {
            this.planData = [];
            this.selectedPlan = null;
            this.currentPatientId = null;
            this.currentPatientName = '未选择';
            this.$message.info('该患者所有计划已执行完成');
          }
        } else {
          this.$message.error(res.message || '执行失败');
        }
      } catch (error) {
        console.error('执行失败:', error);
        this.$message.error('执行失败，请重试');
      } finally {
        this.executeLoading = false;
      }
    },

    /**
     * 刷新当前患者的执行计划（保留分组）
     */
    async refreshCurrentPatientPlans() {
      if (!this.currentPatientId) return;

      this.planLoading = true;
      try {
        const res = await getExecutionPlans({ patientId: this.currentPatientId, planDate: this.selectedDate });
        if (res.code === 200) {
          const rawData = Array.isArray(res.data) ? res.data : [];
          const sortedData = rawData.sort((a, b) => {
            const order = { 0: 0, 1: 1, 2: 2 };
            return (order[a?.planStatus] ?? 99) - (order[b?.planStatus] ?? 99);
          });
          this.planData = this.processPlanGroups(sortedData);

          const patient = this.patientData.find(p => p.patientId === this.currentPatientId);
          if (patient) {
            this.currentPatientName = patient.patientName || '未知';
          }
        } else {
          this.$message.error(res.message || '加载执行计划失败');
          this.planData = [];
        }
      } catch (error) {
        console.error('刷新执行计划失败:', error);
        this.planData = [];
      } finally {
        this.planLoading = false;
      }
    },

    // 关闭执行弹窗
    handleExecuteDialogClosed() {
      this.executeForm = {
        planIds: [],
        executionNo: '',
        itemName: '',
        specification: '',
        quantity: null,
        executionDeptId: null,
        groupKey: null
      };
    },

    // ========== 5. 查看执行记录 ==========
    handleViewRecords() {
      this.recordDialogVisible = true;
      this.recordPageNum = 1;
      this.recordSearchForm = {
        patientId: '',
        patientName: '',
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ]
      };
      this.loadRecords();
    },

    async loadRecords() {
      this.recordDialogLoading = true;
      try {
        const params = {
          pageNum: this.recordPageNum,
          pageSize: this.recordPageSize,
          patientId: this.recordSearchForm.patientId || undefined,
          patientName: this.recordSearchForm.patientName || undefined,
          status: this.recordSearchForm.status !== null && this.recordSearchForm.status !== '' ? this.recordSearchForm.status : undefined,
          startTime: this.recordSearchForm.timeRange?.[0] || undefined,
          endTime: this.recordSearchForm.timeRange?.[1] || undefined
        };
        const res = await getExecutionPlansPage(params);
        if (res.code === 200) {
          this.recordDialogData = res.data?.content || [];
          this.recordTotalSize = res.data?.totalSize || 0;
        } else {
          this.$message.error(res.message || '加载执行记录失败');
        }
      } catch (error) {
        console.error('加载执行记录失败:', error);
        this.$message.error('加载执行记录失败，请重试');
      } finally {
        this.recordDialogLoading = false;
      }
    },

    resetRecordSearch() {
      this.recordSearchForm = {
        patientId: '',
        patientName: '',
        status: null,
        timeRange: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ]
      };
      this.recordPageNum = 1;
      this.loadRecords();
    },

    handleRecordSizeChange(val) {
      this.recordPageSize = val;
      this.recordPageNum = 1;
      this.loadRecords();
    },

    handleRecordCurrentChange(val) {
      this.recordPageNum = val;
      this.loadRecords();
    },

    handleRecordDialogClosed() {
      this.recordDialogData = [];
      this.recordTotalSize = 0;
    },

    // ========== 6. 双击执行记录行 → 查看详情 ==========
    async handleRecordRowDblclick(row) {
      if (!row || !row.id) {
        this.$message.warning('请选择有效的记录');
        return;
      }
      const planId = row.executionPlanId;
      if (!planId) {
        this.$message.warning('该记录无关联的执行计划');
        return;
      }

      this.recordDetailLoading = true;
      this.recordDetailData = {};

      try {
        const res = await getExecutionPlansRecords(planId);
        if (res.code === 200) {
          const records = res.data || [];
          let matchedRecord = records.find(item => item.id === row.id);
          if (!matchedRecord) {
            matchedRecord = records.find(item => item.requestNo === row.requestNo);
          }
          if (matchedRecord) {
            this.recordDetailData = matchedRecord;
            this.recordDetailDialogVisible = true;
          } else if (records.length > 0) {
            this.recordDetailData = records[0];
            this.recordDetailDialogVisible = true;
            this.$message.warning('未找到精确匹配的记录，已展示该计划的第一条记录');
          } else {
            this.$message.warning('该计划暂无执行记录');
          }
        } else {
          this.$message.error(res.message || '加载执行记录详情失败');
        }
      } catch (error) {
        console.error('加载执行记录详情失败:', error);
        this.$message.error('加载执行记录详情失败，请重试');
      } finally {
        this.recordDetailLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* 与之前完全一致，省略 */
.nursing-execution {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;

  .compact-form-box {
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    margin-bottom: 12px;
    padding: 4px 0 0 0;
    /deep/ .el-tabs__header { margin-bottom: 0; }
    /deep/ .el-tabs__content { padding: 8px 15px; }
  }

  .responsive-form {
    .form-row { display: flex; flex-wrap: wrap; }
    .compact-form-item { margin-bottom: 4px; }
    .full-width-input, .full-width-select { width: 100% !important; }
    /deep/ .el-form-item__label { font-size: 12px; padding-right: 6px; }
  }

  .medical-system-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    min-height: 0;
  }

  .table-main-container {
    display: flex;
    height: calc(100% - 50px);
    width: 100%;
    overflow: hidden;
  }

  .left-tabs-container {
    width: 45%;
    min-width: 300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e8ecf1;
  }

  .right-tabs-container {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-width: 400px;
  }

  .left-tabs, .right-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    /deep/ .el-tabs__header { margin-bottom: 0; flex-shrink: 0; }
    /deep/ .el-tabs__content { flex: 1; padding: 0 !important; overflow: hidden; }
    /deep/ .el-tab-pane { height: 100%; }
  }

  .table-container {
    height: 100%;
    overflow: hidden;
    padding: 2px 0 0 0;
    /deep/ .el-table {
      height: 100%;
      .el-table__header-wrapper th { background-color: #f5f7fa; font-weight: 600; }
      .cell { font-size: 12px; }
    }
  }

  .bottom-control-form {
    height: 50px;
    padding: 8px 15px;
    background: #f8f9fa;
    border-top: 1px solid #e8ecf1;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    .action-buttons { display: flex; gap: 10px; }
  }
}

.execute-dialog {
  /deep/ .el-dialog__header {
    padding: 12px 20px; background-color: #67C23A;
    .el-dialog__title { color: #fff; font-size: 16px; }
    .el-dialog__headerbtn .el-dialog__close { color: #fff; }
  }
  /deep/ .el-form-item { margin-bottom: 12px; }
  /deep/ .el-form-item__label { font-size: 12px; }
}

.record-dialog {
  /deep/ .el-dialog__header {
    padding: 12px 20px; background-color: #409EFF;
    .el-dialog__title { color: #fff; font-size: 16px; }
    .el-dialog__headerbtn .el-dialog__close { color: #fff; }
  }
  /deep/ .el-dialog__body { padding: 15px 20px; }
}

.record-detail-dialog {
  /deep/ .el-dialog__header {
    padding: 12px 20px; background-color: #E6A23C;
    .el-dialog__title { color: #fff; font-size: 16px; }
    .el-dialog__headerbtn .el-dialog__close { color: #fff; }
  }
  /deep/ .el-form-item { margin-bottom: 10px; }
  /deep/ .el-form-item__label { font-size: 12px; }
  /deep/ .el-input.is-disabled .el-input__inner {
    color: #303133; background-color: #f5f7fa; border: 1px solid #e8ecf1;
  }
}
</style>